import type {CSSProperties, ReactNode} from 'react';

import {AnimatedDialog} from '../shared/AnimatedDialog';

export type BottomSheetProps = {
  show: boolean;
  onClose?: () => void;
  canceledOnTouchOutside?: boolean;
  canceledOnTouchInside?: boolean;
  children?: ReactNode;
  contentStyle?: CSSProperties;
  headerStyle?: CSSProperties;
  footerStyle?: CSSProperties;
  header?: ReactNode;
  footer?: ReactNode | null;
  defaultHeader?: boolean;
  /** Shows the close (×) button in the default header. Default: true */
  showCloseButton?: boolean;
  title?: string;
  className?: string;
};

export function BottomSheet(props: BottomSheetProps) {
  return <AnimatedDialog {...props} panelMode="bottom" />;
}
